<div class="splash-container">
  <div class="top-container">
    <img src="./assets/icons/icl-logo.svg" class="icl-logo" alt="icl-logo" />
    <h1>
      <span>WELCOME TO</span><br />
      <span class="vibes-logo">VIBEs</span>
    </h1>
  </div>
  <div class="bottom-container">
    <img
    src="assets/images/splash-button.png"
    (click)="launch()"
      class="launch-button"
      alt="splash-button"
      />
    <div class="version">Version: {{ version }}</div>
  </div>
</div>
